import { dashboardConstant } from "../../../../free/constants/dashboardConstants";
const initialState = {};

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case dashboardConstant.UPDATE_CAMPAIGN_REQUEST:
      return {
        loading: true,
      };

    case dashboardConstant.LOAD_CAMPAIGNS_START:
      return {
        loading: action.payload.loading,
      };

    case dashboardConstant.LOAD_CAMPAIGNS:
      return {
        campaigns: action.payload.campaigns,
        loading: action.payload.loading,
      };

    case dashboardConstant.LOAD_CAMPAIGNS_ERROR:
      return {
        message: action.payload.error,
        loading: action.payload.loading,
      };

    case dashboardConstant.UPDATE_CAMPAIGN_DATE:
      return {
        campaigns: action.payload.campaigns,
        loading: action.payload.loading,
      };

    case dashboardConstant.UPDATE_CAMPAIGN_DATE_FAIL:
      return {
        message: action.payload.error,
        loading: action.payload.loading,
      };

    default:
      return state;
  }
}
